module.exports = __webpack_public_path__ + "static/media/school-profile-ad3.b9e85c56.jpg";